import { createSlice } from "@reduxjs/toolkit";
import { getMe, updateMe } from "./meActions";

const initialState = {
  loading: false,
  error: null,
  success: false,
  info: {},
  // [CANA-654] true once /me/ has answered since this page load. Until then
  // the stored permissions may be stale, so Can.js must not treat a page as
  // "allowed then lost" — a reload on a page whose right was removed
  // meanwhile redirects instead of showing Access denied.
  synced: false,
};

const meSlice = createSlice({
  name: "me",
  initialState,
  reducers: {
    resetError: (state) => {
      state.error = null;
      state.loading = false;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMe.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMe.fulfilled, (state, action) => {
        state.loading = false;
        state.info = action.payload;
        state.synced = true;
      })
      .addCase(getMe.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })
      .addCase(updateMe.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateMe.fulfilled, (state, action) => {
        state.loading = false;
        state.info = action.payload;
      })
      .addCase(updateMe.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  },
});
export const { resetError } = meSlice.actions;
export default meSlice.reducer;
